import * as $ from "jquery";
import * as DOMPurify from "../../lib/purify.min.js";
import { debounce } from "throttle-debounce";
declare var ga: any;
declare global {
	interface Window {
		dataLayer: any;
	}
}
/* Search-related functions */
export function init(): void {
	var $searchBox = $('.js-header-quick-search');
	var $searchSubmit = $('.js-header-quick-search-submit');
	var $searchCancel = $('.js-header-quick-search-cancel');
	var $searchInput = $('.js-header-quick-search-input');
	var $searchResults = $('.js-header-quick-search-results');
	var $mainNav = $('.js-main-nav');
	var $body = $('body');
	let searchUrl = $searchBox.data('url');

	let lastSearchTerm = '';	
	
	function freezeBody() {
		$body.addClass('state-quick-search-open');
	}

	function unfreezeBody() {
		$body.removeClass('state-quick-search-open');
	}

	$searchSubmit.on('click', function (e) {

		e.preventDefault();
		e.stopPropagation();		
		let $this = $(this);		
		$mainNav.toggleClass('state-out');
		$searchBox.toggleClass('state-quick-search-visible');

		if ($searchBox.hasClass('state-quick-search-visible')) {
			freezeBody();
			// Hide the nav if it's open
			$('body').removeClass('state-nav-open');
			$('.js-site-nav').removeClass('state-visible');
			$searchInput.val('').get(0).focus();
			$this.addClass('quick-search-box__submit--open');
		} else {
			unfreezeBody();
			$searchResults.removeClass('state-visible');
			$searchInput.blur();
			$this.removeClass('quick-search-box__submit--open');
		}
	});

	function searchApiCall() {
		let $alertDanger = $('.js-alert-danger');
		let $productsViewAll = $('.js-view-all-products');
		let $supportViewAll = $('.js-view-all-support');
		let $pagesViewAll = $('.js-view-all-pages');

		let query = $searchInput.val();
		let sanitizedQuery = DOMPurify.sanitize(query);
		
		$.get(`/api/pff/search?query=${query}&brands=Pfister`)
			.done(function (result) {
				$('.js-quick-search-results-product').empty();
				$('.js-quick-search-results-pages').empty();
				$('.js-quick-search-results-support').empty();

				if (result) {
					var productResult = result.data.Products;
					var pagesResult = result.data.Pages;
					var supportResult = result.data.Support;
					// console.log(result);

					//PRODUCTS OUTPUT
					if (productResult.length) {
						$productsViewAll.removeClass('hidden');

						//set our View All Link to take you to the approppriate area on the search results pages
						$productsViewAll.attr('href', searchUrl + '?FilterCriteria.Query=' + query + '&FilterCriteria.Tab=products');

						//Loop through each product in the product array and return the values
						$.each(productResult, function () {
							$(`<li class="quick-search-results__matching-product product-result">
							<a href="${this.DetailsUrl}" class="product-result__link js-quick-search-result-link">
								<div class="product-result__img">
									<img src="${this.ImageUrl}" alt="${this.DisplayName}">
								</div>
								<div class="product-result__body">` +
								(this.Collection != null ? `<div class="product-result__name">${this.Collection}</div>` : "") + `
									<div class="product-result__desc">${this.DisplayName}</br>${this.AdditionalDisplayName}</div>
									<div class="product-result__model">Model#: ${this.ModelNumber}</div>
								</div>
								<div class="flex-auto margin-right-small product-result__retailer-exclusive">
									<img src="${this.ExclusiveRetailerLogo}?$pfIconLarge$&fmt=png-alpha&fit=constrain" alt="${this.ExclusiveRetailerName}">
								</div>
							</a>
						</li>`).appendTo('.js-quick-search-results-product');
						});
					} else {
						$(`<li class="quick-search-results__matching-product product-result state-no-results">
							<em>No <strong>Product</strong> Results for "${sanitizedQuery}"</em>
						</li>`).appendTo('.js-quick-search-results-product');

						//hide the view all link if there are no results
						$productsViewAll.addClass('hidden');
					}

					//PAGES OUTPUT
					if (pagesResult.length) {
						$pagesViewAll.removeClass('hidden');
						$pagesViewAll.attr('href', searchUrl + '?FilterCriteria.Query=' + query + '&FilterCriteria.Tab=pages');
						$.each(pagesResult, function () {
							$(`<li class="quick-search-results__matching-term">
							<a href="${this.Url}" class="quick-search-results__link js-quick-search-result-link">${this._HighlightResult.Title.Value}</a>
							</li>`).appendTo('.js-quick-search-results-pages');
						});
					} else {
						$(`<li class="quick-search-results__matching-term state-no-results">
							<em>No <strong>Page</strong> Results for "${sanitizedQuery}"</em>
						</li>`).appendTo('.js-quick-search-results-pages');
						//hide the view all link if there are no results
						$pagesViewAll.addClass('hidden');
					}


					if (supportResult.length) {
						$supportViewAll.removeClass('hidden');
						$supportViewAll.attr('href', searchUrl + '?FilterCriteria.Query=' +query + '&FilterCriteria.Tab=support');
						$.each(supportResult, function () {
							var videoType = this.ContentTypeId == "Videos" ? "js-video" : "";
							var urlSelect = this.ContentTypeId == "Videos" ? "https://www.youtube.com/watch?v=" + this.Url : this.Url;
							$(`<li class="quick-search-results__matching-term">
							<a href="${urlSelect}" class="${videoType} quick-search-results__link js-quick-search-result-link">${this._HighlightResult.Title.Value}</a>
							</li>`).appendTo('.js-quick-search-results-support');

						});
					} else {
						$(`<li class="quick-search-results__matching-term state-no-results">
							<em>No <strong>Support</strong> Results for "${sanitizedQuery}"</em>
						</li>`).appendTo('.js-quick-search-results-support');
						$supportViewAll.addClass('hidden');
					}

				} else {
					$alertDanger
						.removeClass('hidden')
						.find('.js-alert-text')
						// TODO: verify this text
						.text('there are no');

					window.scrollTo(0, 0);
				}
			})
			.fail(function (response) {
				console.log('fail:' + response);
			});
	}

	$searchCancel.on('click', function (e) {
		e.preventDefault();
		e.stopPropagation();
		$searchBox.removeClass('state-quick-search-visible');
		unfreezeBody();
		$searchInput.val('');
		$mainNav.removeClass('state-out');
		$searchResults.removeClass('state-visible');
	});


	$searchInput.on('keyup', debounce(500, function (event) {
		let inputValue = $(this).val();

		if (inputValue.length && inputValue !== lastSearchTerm) {
			$searchResults.addClass('state-visible');
			initSearchKeyboardNav();
			searchApiCall();
		} else {
			$searchResults.removeClass('state-visible');
			destroySearchKeyboardNav();
		}

		lastSearchTerm = inputValue;

		//enter click
		if (event.keyCode === 13 && inputValue.length) {
			window.location.href = searchUrl + "?FilterCriteria.Query=" + $(this).val();
		}

		//escape click
		if (event.keyCode === 27) {
			if ($searchSubmit.hasClass('quick-search-box__submit--open')) {
				$searchSubmit.trigger('click');
			}
		}
	}));

	$body.on('hideSearch', function () {
		$('.js-header-quick-search').removeClass('state-quick-search-visible');
		$('.js-header-quick-search-results').removeClass('state-visible');

		destroySearchKeyboardNav();
	});
}

function initSearchKeyboardNav() {
	var $searchNavLists = $('.js-quick-search-results-list');
	var keyboardIndex = -1;
	var listIndex = 0;
	var searchNavElements = [];

	$searchNavLists.each(function () {
		searchNavElements.push($(this).find('a').toArray());
	});

	$(document).on('keyup.searchnav', function (e) {
		let trappedKeys = ['ArrowUp', 'ArrowDown', 'ArrowRight', 'ArrowLeft'];

		if (trappedKeys.indexOf(e.key) >= 0) {
			e.preventDefault();
			// TODO find a fix for Chrome not preventing the arrow keys from firing their default behavior

			switch (e.key) {
				case 'ArrowUp':
					keyboardIndex--;
					break;
				case 'ArrowDown':
					keyboardIndex++;
					break;
				case 'ArrowLeft':
					listIndex--;
					keyboardIndex = 0;
					break;
				case 'ArrowRight':
					listIndex++;
					keyboardIndex = 0;
					break;
			}

			// Constrain the (horizontal) list index
			listIndex = Math.max(0, listIndex);
			listIndex = Math.min(listIndex, searchNavElements.length - 1);

			// Constrain the (vertical) keyboard index to a range from -1 (no list element selected)..length of the currently selected list
			keyboardIndex = Math.max(-1, keyboardIndex);

			// If we're on the last item in a list, but there is another list, wrap to the next one
			if (keyboardIndex > searchNavElements[listIndex].length - 1 && searchNavElements.length > listIndex + 1) {
				keyboardIndex = 0;
				listIndex++;
			} else {
				// Otherwise constrain to the end of the current list
				keyboardIndex = Math.min(keyboardIndex, searchNavElements[listIndex].length - 1);
			}

			if (keyboardIndex === -1) {
				listIndex = 0;
				$('.js-header-quick-search-input').focus();
			} else {
				searchNavElements[listIndex][keyboardIndex].focus();
			}
		}

	});
}

function destroySearchKeyboardNav() {
	$(document).off('keyup.searchnav');
}



// WEBPACK FOOTER //
// ./js/PFF/modules/quickSearch.ts